'use client'

import Script from 'next/script'
import React from 'react'
import { useCookieConsent } from '@/global/hooks/useCookieConsent'

const CLARITY_CONSENT_CATEGORY = 'performance'

export const ClarityScript = () => {
  const projectId = process.env.NEXT_PUBLIC_APP_CLARITY_PROJECT_ID
  const consentGranted = useCookieConsent(CLARITY_CONSENT_CATEGORY)

  if (!projectId) return null
  if (!consentGranted) return null

  return (
    <Script
      id='microsoft-clarity'
      strategy='lazyOnload'
    >
      {`(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${projectId}");`}
    </Script>
  )
}
